/**
 * Constants for matter-scoped file and folder search.
 */

/**
 * API base path for the matter-scoped search endpoints
 * (`/{matter_id}/folders/search` and `/{matter_id}/files/search`).
 */
export const kUserFilesSearchApiBasePath = '/api/v1/matter'

/** Backend maximum page size for both search endpoints (`limit` is capped at 500). */
export const kSearchPageLimit = 500

/**
 * Stopgap safety cap: keep a single query under roughly 5,000 folders and 5,000 files
 * until the drive either virtualizes large lists (and this can expand) or switches to
 * true UI pagination (and this limit can be removed). Hitting the cap returns the pages
 * fetched so far marked `truncated` — a broad query must show partial results, not fail.
 */
export const kMaxSearchPaginationPages = 10

/** Matches the delay the folder/file list fetchers use between pagination requests. */
export const kSearchPaginationRequestDelayMs = 50

/**
 * Page size for the typing path behind the suggestions dropdown. One page only — the dropdown
 * shows a handful of rows, so exhausting the cursor on every keystroke would be wasted work.
 */
export const kSuggestionsPageLimit = 20

/**
 * Longest query the search endpoints accept, mirroring `SearchRequestQuery.query`
 * (`max_length=255`) in `paxton_app/user_files/search/schemas.py`. The backend strips whitespace
 * before validating, and a trimmed query is never longer than what was typed, so capping the raw
 * input is enough to keep every request inside the contract.
 */
export const kMaxSearchQueryLength = 255

/** How long typing must pause before the suggestions request goes out. */
export const kSuggestionsDebounceMs = 250

/** Rows rendered per dropdown section, matching the design's five-file list. */
export const kSuggestionsPerSection = 5

/** How many past queries the field offers before the oldest drops off. */
export const kRecentSearchesLimit = 5
